import script from "./IntermediariesDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./IntermediariesDetail.vue?vue&type=script&setup=true&lang=js"

import "./IntermediariesDetail.vue?vue&type=style&index=0&id=72818f20&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-72818f20"]])

export default __exports__